import script from "./HomeContent7-clients.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContent7-clients.vue?vue&type=script&setup=true&lang=js"

import "./HomeContent7-clients.vue?vue&type=style&index=0&id=90816e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90816e72"]])

export default __exports__